import { useNavigate } from "react-router-dom";
import { Clock, Sparkles, LogIn, MailCheck } from "lucide-react";

export default function Pending() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex flex-col">
      <div className="mx-auto w-full max-w-md flex-1 flex flex-col px-6 pt-16 pb-10">
        <div className="flex items-center gap-2">
          <div className="h-10 w-10 rounded-xl bg-blue-700 flex items-center justify-center"><Sparkles className="text-white" size={20} /></div>
          <span className="font-head text-xl font-bold tracking-tight">Profeeluj<span className="text-blue-700"> AI</span></span>
        </div>

        <div className="flex-1 flex flex-col items-center justify-center text-center">
          <div className="h-20 w-20 rounded-3xl bg-amber-50 flex items-center justify-center">
            <Clock className="text-amber-500" size={40} />
          </div>
          <h1 className="mt-6 font-head text-3xl font-bold tracking-tight">Registrácia prijatá</h1>
          <p className="mt-3 text-slate-600 leading-relaxed" data-testid="pending-message">
            Ďakujeme! Váš účet musí najprv schváliť administrátor. Po schválení Vám pošleme email a budete sa môcť prihlásiť.
          </p>

          <div className="mt-6 flex items-center gap-2 rounded-full bg-blue-50 border border-blue-100 px-4 py-2 text-sm font-medium text-blue-700">
            <MailCheck size={16} /> Oznámenie dostanete emailom
          </div>
        </div>

        <button data-testid="pending-to-login-btn" onClick={() => nav("/login")}
          className="w-full inline-flex items-center justify-center gap-2 bg-blue-700 text-white hover:bg-blue-800 rounded-full px-6 py-4 font-semibold transition-colors active:scale-95">
          <LogIn size={18} /> Prejsť na prihlásenie
        </button>
      </div>
    </div>
  );
}
